// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "not-found" + "." + "e1fca8c8" + ".js";
};